export { WindowTokenModule, WINDOW } from './src/ngx-window-token';
//# sourceMappingURL=ngx-window-token.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-window-token/dist/ngx-window-token.js
// module id = 311
// module chunks = 1